import type { IconDefinition } from '../index.tsx';

export const iconShield: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconShield',
  icon: [
    16,
    16,
    [],
    '',
    'M9.6641 10.8906C9.78299 10.8113 9.89512 10.7244 10 10.6306C10.6313 10.066 11 9.25462 11 8.39445V5.46484L8 4V12L9.6641 10.8906Z M1 3L8 0L15 3V7.35742C15 10.2283 13.4617 12.879 10.9691 14.3034L8 16L5.03089 14.3034C2.53829 12.879 1 10.2283 1 7.35742V3ZM3 7.35742V4.31879L8 2.17594L13 4.31879V7.35742C13 9.51056 11.8463 11.4986 9.97683 12.5669L8 13.6965L6.02317 12.5669C4.15372 11.4986 3 9.51056 3 7.35742Z',
  ],
};
